import React from 'react';
import { FaBox, FaCloudDownloadAlt } from 'react-icons/fa';

const ProductTypeSelector = ({ value, onChange, disabled = false }) => {
  return (
    <div className="form-group row">
      <label className="col-12 col-md-4 col-form-label">
        Product Type <span className="text-danger">*</span>
      </label>
      <div className="col-12 col-md-8">
        <div className="row">
          {/* Physical Product Option */}
          <div className="col-md-6 mb-3">
            <div
              onClick={() => !disabled && onChange('physical')}
              className={`card ${value === 'physical' ? 'border-primary' : 'border-secondary'}`}
              style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                backgroundColor: value === 'physical' ? '#e7f3ff' : '#fff',
                transition: 'all 0.3s'
              }}
            >
              <div className="card-body">
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id="productTypePhysical"
                    name="productType"
                    className="custom-control-input"
                    value="physical"
                    checked={value === 'physical'}
                    onChange={() => onChange('physical')}
                    disabled={disabled}
                  />
                  <label className="custom-control-label" htmlFor="productTypePhysical">
                    <div className="d-flex align-items-center mb-2">
                      <FaBox className="mr-2" style={{ fontSize: '20px', color: '#1E5B3A' }} />
                      <strong>Physical Product</strong>
                    </div>
                    <small className="text-muted">
                      Requires shipping & inventory management
                    </small>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Digital Product Option */}
          <div className="col-md-6 mb-3">
            <div
              onClick={() => !disabled && onChange('digital')}
              className={`card ${value === 'digital' ? 'border-success' : 'border-secondary'}`}
              style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                backgroundColor: value === 'digital' ? '#e7ffe7' : '#fff',
                transition: 'all 0.3s'
              }}
            >
              <div className="card-body">
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id="productTypeDigital"
                    name="productType"
                    className="custom-control-input"
                    value="digital"
                    checked={value === 'digital'}
                    onChange={() => onChange('digital')}
                    disabled={disabled}
                  />
                  <label className="custom-control-label" htmlFor="productTypeDigital">
                    <div className="d-flex align-items-center mb-2">
                      <FaCloudDownloadAlt className="mr-2" style={{ fontSize: '20px', color: '#2E7D4F' }} />
                      <strong>Digital Product (E-Book)</strong>
                    </div>
                    <small className="text-muted">
                      Instant delivery, no shipping required
                    </small>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {disabled && (
          <small className="text-muted">
            <i className="fas fa-info-circle mr-1"></i>
            Product type cannot be changed after creation
          </small>
        )}
      </div>
    </div>
  );
};

export default ProductTypeSelector;
